import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const CategoryIllustrationLargeIcon = ({
    size = 24,
    color = 'currentFill'
}: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 33 32"
        fill={color}
        xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd"
            clipRule="evenodd"
            d="M18.378 18.74v-4.023h-3.983l-.809-5.71 1.97-.285.565 3.986h4.248v4.288l3.948.57-.282 1.989-5.657-.816Z"
            fill="#404145"/>
        <path fillRule="evenodd"
            clipRule="evenodd"
            d="m7.212 28.62 11.461-11.462 1.401 1.428L8.613 30.047 7.212 28.62ZM1.975 25.278 14.566 12.99l1.383 1.445L3.358 26.723l-1.383-1.445ZM22.959 7.6l2.47 2.494-1.408 1.421-2.47-2.493L22.96 7.6Z"
            fill="#404145"/>
        <path fillRule="evenodd"
            clipRule="evenodd"
            d="m1.926 19.987 12.21-12.098 11.771-.826-.818 11.892-11.762 11.762-1.401-1.428 11.23-11.229.607-8.832-8.756.614L3.32 21.422l-1.394-1.435Z"
            fill="#404145"/>
        <path fillRule="evenodd"
            clipRule="evenodd"
            d="M29.333 3.333H4v25.334h25.333V3.333ZM2 1.333v29.334h29.333V1.333H2Z"
            fill="#404145"/>
    </svg>
);
CategoryIllustrationLargeIcon.displayName = 'CategoryIllustrationLargeIcon';
export default CategoryIllustrationLargeIcon;
